import { Component } from '@angular/core';
import { CheckboxButtonComponent } from '../checkbox-button.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-checkbox-yes-no',
  templateUrl: '../checkbox-button.component.html',
  styleUrl: '../checkbox-button.component.scss'
})
export class CheckboxYesNoComponent extends CheckboxButtonComponent{

  override readonly name = 'yesNo'
  override type = 'yesNo'as const

  
  // override transform = (model? : boolean) => {
  //   if (model == undefined) {
  //     return undefined
  //   }
  //   return model ? 'yes' : 'no'
  // }


  constructor(){
    super()
  }
}
